import { EQuizMode } from '@constants';
import { Input } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ItemWrapper, RowWrapper, TitleWrapper, Wrapper } from './QuizConfigurationOptions.styles';

import {
  CourseSearchSelector,
  HoursInput,
  MinutesInput,
  SectionSearchSelector
} from '@/components/Form';
import { useQuizForm } from '@/hooks';
import { useCourseDetail } from '@/store';

export const QuizConfigurationOptions = () => {
  const { config, setConfig } = useQuizForm();
  const { t } = useTranslation('CommonQuizFormTranslations');

  const { courseId } = useCourseDetail();

  const [hours, setHours] = useState<number>();
  const [minutes, setMinutes] = useState<number>(config.timer ? config.timer % 60 : 30);

  const handleHoursChange = (value?: number) => {
    setHours(value);
    setConfig({ ...config, timer: value ? value * 60 + minutes : minutes });
  };

  const handleMinutesChange = (value?: number) => {
    setMinutes(value ?? 0);
    setConfig({ ...config, timer: hours ? hours * 60 + (value ?? 0) : value ?? 0 });
  };

  useEffect(() => {
    if (courseId) {
      const currentConfig = useQuizForm.getState().config;
      setConfig({ ...currentConfig, course: courseId, section: undefined });
    }
  }, [courseId, setConfig]);

  return (
    <Wrapper>
      <ItemWrapper>
        <TitleWrapper>{t('QUIZ_TITLE_FOR_MODE', { mode: t(config.mode) })}</TitleWrapper>
        <Input
          autoFocus={false}
          placeholder={t('QUIZ_TITLE_PLACEHOLDER')}
          value={config.title}
          onChange={e => setConfig({ ...config, title: e.target.value })}
        />
      </ItemWrapper>
      {!courseId && (
        <ItemWrapper>
          <TitleWrapper>{t('COURSE')}</TitleWrapper>
          <CourseSearchSelector
            allowClear
            style={{ width: '100%' }}
            value={config.course}
            onChange={v => setConfig({ ...config, course: v as string })}
          />
        </ItemWrapper>
      )}
      <ItemWrapper>
        <TitleWrapper>{t('SECTION')}</TitleWrapper>
        <SectionSearchSelector
          allowClear
          disabled={!config.course}
          style={{ width: '100%' }}
          courseId={config.course}
          value={config.section}
          onChange={v => setConfig({ ...config, section: v as string })}
        />
      </ItemWrapper>
      {(config.mode === EQuizMode.PRACTICE || config.mode === EQuizMode.PRACTICAL_CASE) && (
        <ItemWrapper>
          <TitleWrapper>{t('EXAM_DURATION')}</TitleWrapper>
          <RowWrapper>
            <HoursInput value={hours} onChange={handleHoursChange} />
            <MinutesInput value={minutes} onChange={handleMinutesChange} />
          </RowWrapper>
        </ItemWrapper>
      )}
    </Wrapper>
  );
};
